module.exports = __webpack_public_path__ + "img/sbp_active.9cca0bcc.svg";